import Image from 'next/image';

export default function ProductDataSheet({ data }) {
  const showType = [
    'pdf_property',
    'certification_data_property',
    'industry_information',
    'reference_designs_property',
  ];

  const pdfUrl = data?.productRecord?.fileTypeVOList?.filter((item) => showType.includes(item.fileType))[0]
    ?.detailVOList?.[0]?.fileUrl;

  const handleViewPdf = () => {
    const lcscAttaUrl = 'https://atta.szlcsc.com';
    const url = `https://static.szlcsc.com/ecp/assets/app/generic-plus/web/viewer.html?file=${lcscAttaUrl}/${pdfUrl}`;
    window.open(url);
  };

  return pdfUrl ? (
    <section className="mt-[26px] px-4 py-3 flex items-center justify-between shadow-[inset_0_-1px_rgba(236,236,236,0.5)]">
      <h2 className="text-[14px]">数据手册</h2>
      <div className="flex items-center text-[12px]" onClick={handleViewPdf}>
        <Image
          src="https://static.szlcsc.com/ecp/assets/app/product-detail/pdf.png"
          alt="查看"
          width={20}
          height={20}
        ></Image>
        <span className="ml-[4px]">查看</span>
      </div>
    </section>
  ) : (
    <></>
  );
}
